import { Trans } from '@lingui/macro';
import { IdUsersStateDataItem } from 'model/dashboardUsers/dUsersReducer';


export enum USERPOSITIONS {
    ADMIN = 'ADMIN',
    EMPLOYEE = 'EMPLOYEE',
    SUPPORT = 'SUPPORT',
    MANAGER = 'MANAGER',
    COURIER = 'COURIER',
    JUNIOR_COURIER = 'JUNIOR_COURIER',
    CASHIER = 'CASHIER',
    DISTRIBUTOR = 'DISTRIBUTOR',
    HEADCASHIER = 'HEADCASHIER'

}

export const POSITION_WITH_FULL_ACCESS = [ USERPOSITIONS.ADMIN, USERPOSITIONS.MANAGER, USERPOSITIONS.HEADCASHIER ]
export const POSITION_WITHOUT_ACCESS = [ USERPOSITIONS.COURIER, USERPOSITIONS.JUNIOR_COURIER, USERPOSITIONS.DISTRIBUTOR ]

export const POSITION_ALLOW_CREATE_USERS = [ USERPOSITIONS.ADMIN, USERPOSITIONS.MANAGER ]

export const POSITION_ALLOW_FULL_CRUD_PRODUCTS= [ USERPOSITIONS.ADMIN, USERPOSITIONS.MANAGER ]

export const getTransPosition = (position: string): any => {
    switch (position) {
        case USERPOSITIONS.EMPLOYEE:
            return <Trans>Employee</Trans>
        case USERPOSITIONS.SUPPORT:
            return <Trans>Support</Trans>
        case USERPOSITIONS.MANAGER:
            return <Trans>Manager</Trans>
        case USERPOSITIONS.ADMIN:
            return <Trans>Admin</Trans>
        case USERPOSITIONS.COURIER:
            return <Trans>Courier</Trans>
        case USERPOSITIONS.JUNIOR_COURIER:
            return <Trans>Courier jr.</Trans>
        case USERPOSITIONS.CASHIER:
            return <Trans>Cashier</Trans>
        case USERPOSITIONS.DISTRIBUTOR:
            return <Trans>Distributor</Trans>
        case USERPOSITIONS.HEADCASHIER:
            return <Trans>Senior cashier</Trans>
        default:
            return position
    }
}


export const allowEditUser = (position: USERPOSITIONS, userIdFromStore: string, userFromItem: IdUsersStateDataItem): boolean => {

    switch (position) {
        case USERPOSITIONS.ADMIN:
            return true
        case USERPOSITIONS.MANAGER:
            if (userIdFromStore === userFromItem.id) {return true} else {
                return !( userFromItem.position === USERPOSITIONS.ADMIN || userFromItem.position === USERPOSITIONS.MANAGER )
            }
        default:
            return false
    }


}
